function BankAccountInfo() {
  const bankAccountInfo = {
    bankName: "우리은행",
    accountNumber: "1002-448-341149",
    accountHolder: "이규호",
  };

  return (
    <div className="w-full max-w-[320px] bg-[#F3EDFF] border border-[#9D7FDE] rounded-xl p-5 text-center text-xl font-bold text-[#222] mb-4 shadow-sm">
      {bankAccountInfo.bankName} {bankAccountInfo.accountNumber}
      <br />
      {bankAccountInfo.accountHolder}
    </div>
  );
}

export default BankAccountInfo;
